import React from 'react';
import { Badge, ListGroup, ListGroupItem } from 'reactstrap';

interface ISidebarProps {
  currentStep: number;
}

const Sidebar = ({ currentStep }: ISidebarProps) => (
  <ListGroup>
    <ListGroupItem
      className={`d-flex justify-content-between align-items-center border-0 p-4 ${
        currentStep >= 1 && currentStep <= 4 ? 'list-group-item-dark' : ''
      }`}
    >
      Determine Location
      <Badge color={currentStep >= 4 ? 'success' : 'secondary'} pill>
        {currentStep >= 4 ? '✓' : 1}
      </Badge>
    </ListGroupItem>
    <ListGroupItem
      className={`d-flex justify-content-between align-items-center border-0 p-4 ${currentStep === 5 ? 'list-group-item-dark' : ''}`}
    >
      Determine Eligibility
      <Badge color={currentStep > 5 ? 'success' : 'secondary'} pill>
        {currentStep > 5 ? '✓' : 2}
      </Badge>
    </ListGroupItem>
    <ListGroupItem
      className={`d-flex justify-content-between align-items-center border-0 p-4 ${
        currentStep >= 6 && currentStep <= 8 ? 'list-group-item-dark' : ''
      }`}
    >
      Add Case Information
      <Badge color={currentStep > 8 ? 'success' : 'secondary'} pill>
        {currentStep > 8 ? '✓' : 3}
      </Badge>
    </ListGroupItem>
    <ListGroupItem
      className={`d-flex justify-content-between align-items-center border-0 p-4 ${currentStep >= 9 ? 'list-group-item-dark' : ''}`}
    >
      Add Symptoms
      <Badge color="secondary" pill>4</Badge>
    </ListGroupItem>
  </ListGroup>
);

export default Sidebar;
